import React from 'react';
import { Helmet } from 'react-helmet-async';
import { PageHero } from '../Common/PageLayout';
import DirectorateList from './DirectorateList';

const breadcrumbs = [
    { label: 'About the Ministry', to: '/profile' },
    { label: 'Directorates' },
];

/** Directory of every directorate within the Ministry of Finance. */
export default function DirectoratesPage() {
    return (
        <>
            <Helmet>
                <title>Directorates | Ministry of Finance, Timor-Leste</title>
                <meta
                    name="description"
                    content="Directorates and national directorates of the Ministry of Finance of Timor-Leste, and the areas of public financial management each one leads."
                />
            </Helmet>

            <PageHero
                eyebrow="About the Ministry"
                title="Directorates"
                description="The Ministry delivers its mandate through directorates covering budget, treasury, revenue, state assets, procurement policy and corporate services."
                breadcrumbs={breadcrumbs}
            />

            <DirectorateList />
        </>
    );
}
